import type { KioskRegistrationEvent } from '../../types/kioskRegistration.types';
import { formatDateTime, STATUS_LABELS } from './registrationUi';

export default function RegistrationAuditTrail({ events }: { events: KioskRegistrationEvent[] }) {
  if (!events?.length) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No activity recorded yet.</p>;
  }
  return (
    <ol className="space-y-3 border-l border-gray-200 pl-4 dark:border-white/10">
      {events.map((event) => (
        <li key={event.id} className="text-sm">
          <p className="font-semibold text-gray-900 dark:text-gray-100">
            {event.action.replace(/_/g, ' ')}
            {event.toStatus && event.fromStatus !== event.toStatus && (
              <span className="ml-2 font-normal text-gray-600 dark:text-gray-300">
                {event.fromStatus ? `${STATUS_LABELS[event.fromStatus] ?? event.fromStatus} → ` : '→ '}
                {STATUS_LABELS[event.toStatus] ?? event.toStatus}
              </span>
            )}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatDateTime(event.createdAt)} · {event.actorEmail || 'System'}
            {event.actorRole ? ` (${event.actorRole})` : ''}
          </p>
          {event.note && <p className="mt-1 whitespace-pre-wrap break-words text-gray-700 dark:text-gray-200">{event.note}</p>}
        </li>
      ))}
    </ol>
  );
}
